import { render, staticRenderFns } from "./PaymentInquiry.vue?vue&type=template&id=d2353816&scoped=true&"
import script from "./PaymentInquiry.vue?vue&type=script&lang=js&"
export * from "./PaymentInquiry.vue?vue&type=script&lang=js&"
import style0 from "./PaymentInquiry.vue?vue&type=style&index=0&id=d2353816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2353816",
  null
  
)

export default component.exports